import React, { Component } from "react";
import ScLayoutTabExample from "../components/layout/scLayoutTabExample";

class Example extends Component {
  render() {
    return (
      <div>
        <ScLayoutTabExample />
      </div>
    );
  }
}

export default Example;



// WEBPACK FOOTER //
// ./src/AntD/pages/example.js